module.exports = __webpack_public_path__ + "img/msg.169f32ae.png";